import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { readThemePreference, saveThemePreference, THEME_PREFERENCES } from '../theme.js';
import type { ThemePreference } from '../theme.js';

/**
 * Hell, dunkel — oder dem Gerät folgen.
 *
 * „Gerät" steht bewusst zuerst und ist die Vorgabe: Wer nachts trainiert, hat
 * sein Telefon längst umgestellt. Die beiden festen Wahlmöglichkeiten sind für
 * den Fall, dass die Systemvorgabe im Gym nicht passt — grelles Deckenlicht auf
 * dunkler Anzeige ist schlecht ablesbar, und umgekehrt.
 */
export function ThemeToggle(): React.JSX.Element {
  const { t } = useTranslation();
  const [preference, setPreference] = useState<ThemePreference>(() => readThemePreference());

  return (
    <div className="flex flex-col gap-2">
      <span className="kw-label" id="theme-label">
        {t('theme.heading')}
      </span>
      <div role="group" aria-labelledby="theme-label" className="flex gap-2">
        {THEME_PREFERENCES.map((option) => (
          <button
            key={option}
            type="button"
            aria-pressed={preference === option}
            onClick={() => {
              saveThemePreference(option);
              setPreference(option);
            }}
            className={`kw-btn kw-btn-small flex-1 ${
              preference === option ? '' : 'kw-btn-quiet text-ink'
            }`}
          >
            {t(`theme.${option}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
